import { createAction } from 'redux-actions';
import { Gruser, GruserPage } from '../../types/papi';

export const fetchPageSuccess = createAction(
  '@@gruser.PAGE.FETCH.SUCCESS',
  (gruser: Gruser, payload: GruserPage) => ({
    ...payload,
    gruser,
  })
);
